import wixSeo from 'wix-seo';

$w.onReady( () => {

  wixSeo.setStructuredData(

    [ 

      {
        "@context": "https://schema.org",
        "@type": "GovernmentOffice",
        "name": "The Office of Disciplinary Counsel",
        "url": "odc.ohio.gov",
        "description": "Ohio Disciplinary Counsel.",
        "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "65 East State Street, ste 1510",
                    "addressLocality": "Columbus",
                    "addressRegion": "Ohio",
                    "postalCode": "43215",
                    "addressCountry": "United States of America"
                  },

        
        "openingHours": "Mo, Tu, We, Th, Fr 08:00-17:00",
            "contactPoint": {
                            "@type": "ContactPoint",
                            "telephone": "614-387-9700",
                            "contactType": "Phone"
                            }
        }    
    ]
)

  .then( () => {

    console.log("structured data set");

  } )

  .catch( () => {

    console.log("failed setting structured data");

  } );

} );
